import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Internal dependencies
 */
import { iterateDescendants, iteratePath, hasConflictingLock, getNode } from './utils';
export function __unstableGetPendingLockRequests(state) {
  return state.locks.requests;
}
export function __unstableIsLockAvailable(state, store, path, _ref) {
  var exclusive = _ref.exclusive;
  var storePath = [store].concat(_toConsumableArray(path));
  var locks = state.locks.tree; // Validate all parents and the node itself

  var _iterator = _createForOfIteratorHelper(iteratePath(locks, storePath)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _node = _step.value;

      if (hasConflictingLock({
        exclusive: exclusive
      }, _node.locks)) {
        return false;
      }
    } // iteratePath terminates early if path is unreachable, let's
    // re-fetch the node and check it exists in the tree.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var node = getNode(locks, storePath);

  if (!node) {
    return true;
  } // Validate all nested nodes


  var _iterator2 = _createForOfIteratorHelper(iterateDescendants(node)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var descendant = _step2.value;

      if (hasConflictingLock({
        exclusive: exclusive
      }, descendant.locks)) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return true;
}
//# sourceMappingURL=selectors.js.map